import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * Events Feature Slice
 * 
 * Manages local UI state for events (view mode, filters, etc.)
 * Data fetching is handled by RTK Query in services/api/endpoints/events.ts
 */

interface EventsState {
  viewMode: 'cards' | 'list';
  activeEventIndex: number;
  isHovering: boolean;
  filters: {
    category?: string;
    dateRange?: {
      start: string;
      end: string;
    };
  };
}

const initialState: EventsState = {
  viewMode: 'cards',
  activeEventIndex: 0,
  isHovering: false,
  filters: {},
};

const eventsSlice = createSlice({
  name: 'events',
  initialState,
  reducers: {
    setViewMode: (state, action: PayloadAction<'cards' | 'list'>) => {
      state.viewMode = action.payload;
    },
    setActiveEvent: (state, action: PayloadAction<number>) => {
      state.activeEventIndex = action.payload;
    },
    setIsHovering: (state, action: PayloadAction<boolean>) => {
      state.isHovering = action.payload;
    },
    setCategoryFilter: (state, action: PayloadAction<string | undefined>) => {
      state.filters.category = action.payload;
    },
    setDateRangeFilter: (
      state,
      action: PayloadAction<{ start: string; end: string } | undefined>
    ) => {
      state.filters.dateRange = action.payload;
    },
    clearFilters: (state) => {
      state.filters = {};
    },
  },
});

export const {
  setViewMode,
  setActiveEvent,
  setIsHovering,
  setCategoryFilter,
  setDateRangeFilter,
  clearFilters,
} = eventsSlice.actions;

export default eventsSlice.reducer;

